export default function NewShareIcon() {
    return (
        <svg
            width='22'
            height='19'
            viewBox='0 0 22 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M21.5 9.0568L13.3333 0.890137V5.5568C5.16667 6.72347 1.66667 12.5568 0.5 18.3901C3.41667 14.3068 7.5 12.4401 13.3333 12.4401V17.2235L21.5 9.0568Z'
                fill='white'
            />
        </svg>
    );
}
